import type { LoginFormDataType, SignUpFormDataType } from '@/schemas';
import type {
  AccountMeSuccessResponse,
  RefreshAccessTokenSuccessResponse,
  SignInSuccessResponse,
  SignUpSuccessResponse,
} from '@/types';
import { getRefreshToken } from '@/lib/utils/auth';

import axiosInstance from './axiosInstance';

export const logInAccount = (
  data: LoginFormDataType
): Promise<SignInSuccessResponse> =>
  axiosInstance.post(`/account/login`, {
    email_address: data.email_address,
    password: data.password,
  });

export const resetPassword = (
  email_address: string,
  new_password: string,
  valid_token: string
): Promise<unknown> =>
  axiosInstance.post(`/account/reset-password`, {
    email_address,
    new_password,
    valid_token,
  });

export const resetPasswordRequest = (email_address: string): Promise<unknown> =>
  axiosInstance.post(`/account/request-reset-password`, {
    email_address,
  });

export const createAccount = (
  data: SignUpFormDataType
): Promise<SignUpSuccessResponse> => {
  return axiosInstance.post(`/account/signup`, {
    email_address: data.email_address,
    first_name: data.first_name,
    last_name: data.last_name,
    password: data.password,
  });
};

export const refreshAccessToken = async (
  refreshToken?: string | undefined
): Promise<RefreshAccessTokenSuccessResponse> => {
  let rt = refreshToken;
  if (!rt) {
    rt = getRefreshToken();
  }
  return await axiosInstance.post(`/account/refresh`, undefined, {
    headers: {
      Authorization: `Bearer ${rt}`,
    },
  });
};

export const getAccount = (): Promise<AccountMeSuccessResponse> =>
  axiosInstance.get(`/account/me`);
